import { render, staticRenderFns } from "./DictDoh.vue?vue&type=template&id=2df6c6a9&"
import script from "./DictDoh.vue?vue&type=script&lang=js&"
export * from "./DictDoh.vue?vue&type=script&lang=js&"
import style0 from "./DictDoh.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports